import { type ComponentType, Fragment, type ReactElement, createElement } from "react"

import { useNetworkState } from "react-use"
import type { IUseNetworkState } from "react-use/lib/useNetworkState"

import { networkConfigGuardConfig as config } from "./network-notice.config"
import { ENetworkNoticeFallbackVariant as EFallbackVariant } from "./network-notice.types"

const withNetworkGuard = <TProps extends object>(
    WrappedComponent: ComponentType<TProps>,
    fallbackVariant: EFallbackVariant = EFallbackVariant.OwlSad
): ((props: TProps) => ReactElement) => {
    // eslint-disable-next-line react/display-name
    return (props: TProps): ReactElement => {
        const { online }: IUseNetworkState = useNetworkState()

        return createElement(
            Fragment,
            null,
            createElement(WrappedComponent, props),
            !online &&
                createElement(
                    "div",
                    {
                        className:
                            "fixed inset-0 z-[100] overflow-y-auto bg-white/95 backdrop-blur-sm pointer-events-auto"
                    },
                    createElement(config[fallbackVariant])
                )
        )
    }
}

export { withNetworkGuard }
